import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ShowEventInGroup } from '../Partials/Helper';
import { requestGet } from '../../api/request';
import { EVENT_SEARCH_BY_GROUP } from '../../api/url';
import * as actions from '../../redux/actions';

const Sessions = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [searchParams, setSearchParams] = useSearchParams();

  const [event, setEvent] = useState({});
  const [currentPage, setCurrentPage] = useState(+searchParams.get('page') || undefined);

  const getData = async () => {
    setLoader(true);
    const response = await requestGet(EVENT_SEARCH_BY_GROUP, {
      'event_type': 'government_assembly',
      'page': currentPage,
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setLoader(false);
      setEvent(response.data);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 1) {
      searchParams.set('page', +pageNumber);
    } else {
      searchParams.delete('page');
      setCurrentPage(1);
    }
    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (event) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  useEffect(() => {
    // Handle page url params;
    if (+searchParams.get('page') > 1) {
      setCurrentPage(+searchParams.get('page'));
    }
  }, [searchParams]);

  useEffect(() => {
    getData();
  }, [currentPage, currentLanguage]);

  return (
    <div
      className="tab-pane fade show active"
      id="sessions"
      role="tabpanel"
      aria-labelledby="sessions-tab"
    >
      {loader === true ? (
        <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only" />
          </div>
        </div>
      ) : null}
      {event.data && event.data.length > 0 ? (
        <div
          className="tab-pane fade show active"
          id="#meetings_tab"
          role="tabpanel"
          aria-labelledby="#meetings_tab"
        >
          <div className="meetings-container">
            <ShowEventInGroup event={event} groupType="government_sessions" />
          </div>
          {event.last_page > 1
            ? (
              <Pagination
                activePage={currentPage || 1}
                totalItemsCount={event.data ? event.total : 0}
                onChange={(pageNumber) => handlePageChange(pageNumber)}
                pageRangeDisplayed={14}
                itemclassName=""
                linkclassName=""
                firstPageText={dictionary.pagination_prev}
                lastPageText={dictionary.pagination_last}
                prevPageText={dictionary.pagination_first}
                nextPageText={dictionary.pagination_next}
                innerClass="paginations d-lg-flex flex-wrap"
                hideDisabled={true}
              />
            ) : null }
        </div>
      ) : null}
    </div>
  );
};

export default Sessions;
